import {translater} from '../tools/translate';

export const roles = [
	{
		value: 'moderator',
		text: translater.__('moderator', 'users')
	},
	{
		value: 'admin',
		text: translater.__('admin', 'users')
	},
	
	{
		value: 'guest',
		text: translater.__('guest', 'users')
	}
]